export default "__VITE_ASSET__B24wKY7t__"